/**
 * Dock copy — every visible string and accessible name, RU + EN.
 * RU keeps its normal dashes; EN uses colons and plain words.
 */

import type { Lang } from '@/i18n/config';
import type { Bilingual } from '../types';

export const DOCK_COPY = {
  group: { ru: 'Управление демо', en: 'Demo controls' },
  prev: { ru: 'Предыдущая сцена', en: 'Previous scene' },
  next: { ru: 'Следующая сцена', en: 'Next scene' },
  scenes: { ru: 'Сцены', en: 'Scenes' },
  lens: { ru: 'Линза', en: 'Lens' },
  lensPick: { ru: 'Сменить линзу', en: 'Change the lens' },
  play: { ru: 'Запустить рассказ', en: 'Play the tour' },
  resume: { ru: 'Продолжить рассказ', en: 'Resume the tour' },
  pause: { ru: 'Приостановить рассказ', en: 'Pause the tour' },
  pauseShort: { ru: 'Пауза', en: 'Pause' },
  replay: { ru: 'Сначала', en: 'Replay' },
  ask: { ru: 'Спросить AI', en: 'Ask AI' },
  map: { ru: 'Карта сцен', en: 'Scene map' },
  share: { ru: 'Поделиться ссылкой', en: 'Share the link' },
  deconstruct: { ru: 'Разобрать сцену', en: 'Deconstruct the scene' },
  fullscreen: { ru: 'Во весь экран', en: 'Fullscreen' },
  exitFullscreen: { ru: 'Выйти из полноэкранного режима', en: 'Exit fullscreen' },
  help: { ru: 'Клавиши и помощь', en: 'Keys and help' },
  space: { ru: 'Пробел', en: 'Space' },
} satisfies Record<string, Bilingual>;

export function sceneAria(lang: Lang, n: number, total: number, label: string): string {
  return lang === 'ru' ? `Сцена ${n} из ${total} — ${label}` : `Scene ${n} of ${total}: ${label}`;
}

export function lensAria(lang: Lang, label: string): string {
  return lang === 'ru' ? `Линза: ${label}` : `Lens: ${label}`;
}
